import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { EnvService } from '@app/core/services/env.service';
import { InsightAppIds } from '@app/core/utils/insight-app-ids';
import * as $ from 'jquery';
import { RouterOutlet } from '@angular/router';
import { OutageModalComponent } from '@app/shared/outage-modal/outage-modal.component';

window['$'] = $;
window['jQuery'] = $;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, OutageModalComponent],
})
export class AppComponent implements OnInit {
  constructor(
    private meta: Meta,
    private envService: EnvService,
  ) {}

  ngOnInit() {
    this.addInsightAppMeta();
  }

  addInsightAppMeta() {
    const env = this.envService.getEnv();
    if (!InsightAppIds[env]) {
      return;
    }
    this.meta.addTag({
      name: 'insight-app-sec-validation',
      content: InsightAppIds[env],
    });
  }
}
